// axiosConfig.js
import axios from "axios";
import { API_BASE_URL, API_ENDPOINTS } from "../config/urls";

const api = axios.create({
  baseURL: API_BASE_URL,
  // You can add more default config here (headers, timeout, etc)
});

export default api;
export { API_ENDPOINTS };

export const PARAMS = {
  TICKET_ID: 'ticketId',
};
